import { Company } from './../../models/CompanyDTO';
import { User } from './../../models/User';
import { UserProfileActions } from './userprofile.actions';
import { InitializerAction } from '../initializer/initiliazer.action';
import { Profile } from './../../models/Profile';

export class UserProfileState {
    public data: any;
    public user: User;
    public virtualUser: User;
    public userChanges: User;
    public company: Company;
    public pending: boolean;
    public errors: any;
    public riskModel: number;
    public riskModelPending: boolean;
    public riskGarantyModel: boolean;
    public riskGarantyPending: boolean;
    public profile: Profile;
}

export const initialState: UserProfileState = {
    data: [],
    user: new User(),
    virtualUser: new User(),
    userChanges: new User(),
    company: new Company(),
    pending: false,
    errors: null,
    riskModel: null,
    riskModelPending: false,
    riskGarantyModel: false,
    riskGarantyPending: false,
    profile: new Profile()
};

export function UserProfileReducer(state = initialState, { type, payload }) {

    switch (type) {

        case UserProfileActions.getttingUser:
            return { ...state, ...{ user: state.user, errors: null, pending: true }};

        case UserProfileActions.getUserError:
            return { ...state, ...{ errors: payload, pending: false }};

        case UserProfileActions.getUserSuccess: {
            if (!state.virtualUser || !state.virtualUser.id) state.virtualUser = payload;
            return { ...state, ...{ user: payload, pending: false, errors: null}};
        }

        case UserProfileActions.getCompany:
            return { ...state, ...{ user: state.company, errors: null, pending: true }};

        case UserProfileActions.getCompanyError:
            return { ...state, ...{ errors: payload, pending: false }};

        case UserProfileActions.getCompanySuccess:
            return { ...state, ...{ user: payload, pending: false, errors: null}};

        case UserProfileActions.update:
            return { ...state, ...{ pending: true, errors: null}};

        case UserProfileActions.updateSuccess: {
            const user = { ...state.user, ...payload };
            return { ...state, user, virtualUser: user, pending: false, errors: null };
        }

        case UserProfileActions.updateVirtualUser: {
            return { ...state, virtualUser: { ...state.virtualUser, ...payload } };
        }

        case UserProfileActions.updateError:
            return { ...state, ...{ pending: false, errors: payload } };

        case UserProfileActions.insertBankSuccess:
            return { ...state, ...{ user: {bankAccounts: [...state.user.bankAccounts, payload]}, pending: false, errors: null}};

        case UserProfileActions.deleteBankSuccess:
            return {
                ...state,
                ...{
                    user: {
                        bankAccounts: state.user.bankAccounts.filter((bank) => bank.id !== payload),
                    },
                    pending: false,
                    errors: null,
                },
            };

        case UserProfileActions.lazyUpdate:
            return { ...state, ...{ pending: true, errors: null}};

        case UserProfileActions.lazyUpdateSuccess:
            return { ...state, ...{ pending: false, errors: null}};

        case UserProfileActions.reset:
            return { ...state, ...{ user: new User(), pending: false, errors: null } };

        case UserProfileActions.updatePatch:
            return { ...state, ...{ pending: true, errors: null}};

        case UserProfileActions.updatePatchSuccess:
            return { ...state, ...{ user: payload, pending: false, errors: null}};

        case UserProfileActions.updatePatchError:
            return { ...state, ...{ pending: false, errors: payload } };

        case UserProfileActions.updateTags:
            return { ...state, ...{ pending: true, errors: null}};

        case UserProfileActions.updateTagsSuccess:
            return { ...state, ...{ userTag: payload, pending: false, errors: null}};

        case UserProfileActions.updateTagsError:
            return { ...state, ...{ pending: false, errors: payload } };

        case UserProfileActions.updateCompany:
            return { ...state, ...{ pending: true, errors: null}};

        case UserProfileActions.updateCompanySuccess:
            return { ...state, ...{ user: payload, pending: false, errors: null}};

        case UserProfileActions.updateCompanyError:
            return { ...state, ...{ pending: false, errors: payload } };

        // modelo de risco
        case UserProfileActions.getRiskModel:
            return {...state, ...{riskModelPending: true}};

        case UserProfileActions.getRiskModelSuccess:
            return {...state, ...{riskModel: payload, riskModelPending: false}};

        case UserProfileActions.getRiskModelError:
            return {...state, ...{error: payload, riskModelPending: false}};

        // garantia
        case UserProfileActions.getGarantyModel:
            return {...state, ...{riskGarantyPending: true}};

        case UserProfileActions.getGarantyModelSuccess:
            return {...state, ...{riskGarantyModel: payload, riskGarantyPending: false}};

        case UserProfileActions.getGarantyModelError:
            return {...state, ...{error: payload, riskGarantyPending: false}};

        // atualiza o modelo de risco
        case UserProfileActions.updateRiskModel:
            return {...state, ...{riskModelPending: true}};

        case UserProfileActions.updateRiskModelError:
            return {...state, ...{riskModelPending: false, error: payload}};

        case UserProfileActions.updateRiskModelSuccess:
            return {...state, ...{riskModelPending: false, riskModel: payload}};

        // reset current user
        case InitializerAction.resetUserRelatedData:
            return {...state, ...{user: initialState.user, company: initialState.company, riskModel: initialState.riskModel }};

        // Update phone
        case UserProfileActions.updatePhone:
            return { ...state, ...{ pending: true } };

        case UserProfileActions.updatePhoneSuccess:
            return { ...state, ...{ pending: false } };

        case UserProfileActions.updatePhoneError:
            return { ...state, ...{ pending: true } };

        case UserProfileActions.saveUpdatesReregister:
            return { ...state, ...{ userChanges: { ...state.userChanges, ...payload } }};

        // Trader

        case UserProfileActions.getTrader:
            return { ...state, ...{ profile: state.profile, errors: null, pending: true }};

        case UserProfileActions.getTraderError:
            return { ...state, ...{ errors: payload, pending: false }};

        case UserProfileActions.getTraderSuccess:
            return { ...state, ...{ profile: payload, pending: false, errors: null}};

        default:
            return state;
    }
}
